import React from 'react'
import { Control, useController } from 'react-hook-form'
import { useTranslation } from 'next-i18next'

import Input from '@/components/form/Input'
import { EMAIL_REGEX } from '@/constants'

import { SubscribersFormType } from '@/components/landing/type'

interface Props {
  control: Control<SubscribersFormType>
}

function EmailController(props: Props) {
  const { control } = props
  const { t } = useTranslation(['landing', 'common'])
  const { field, fieldState } = useController<SubscribersFormType, 'email'>({
    control,
    name: 'email',
    defaultValue: '',
    rules: {
      required: {
        value: true,
        message: t('common:form.errors.required')
      },
      pattern: {
        value: EMAIL_REGEX,
        message: t('common:form.errors.email')
      }
    }
  })

  return (
    <Input
      ref={field.ref}
      type="email"
      label={t('landing:form.email')}
      placeholder={t('landing:form.email')}
      value={field.value}
      error={fieldState.error?.message}
      onChange={field.onChange}
      onBlur={field.onBlur}
      hideLabel
    />
  )
}

export default EmailController
